// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import 'jquery'
import 'bootstrap'
import 'popper.js'
import 'util'
import "trix"
import "@rails/actiontext"
import '@nathanvda/cocoon'
import 'bootstrap-icons/font/bootstrap-icons.css'
import * as Turbo from "@hotwired/turbo"
import '../extra/turbo_dev_config'
import '../extra/tooltips'
import '../extra/recurring_invoice_notes'
import '../extra/bootstrap-tables'

Rails.start()
ActiveStorage.start()

import "controllers"

require("trix")
require("@rails/actiontext")

import '../extra/react_loader'
